module.exports = __webpack_public_path__ + "static/media/salvadodetrigo.f805cf98.png";